export interface RecordingSegmentView {
  artifact_id: string;
  artifact_name: string;
  source_recording_id: string;
  source_media_id: string;
  start: number;
  end: number;
  remarks?: string;
  segment_order?: number | null;
}

export const createEmptyRecordingSegment = (): RecordingSegmentView => ({
  artifact_id: '',
  artifact_name: '',
  source_recording_id: '',
  source_media_id: '',
  start: 0,
  end: 0,
  remarks: '',
});
